"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/credit-report-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fcredit-report-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditReportTestApiServiceClient = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const credit_report_testing_service_1 = require("../credit-report/testing/credit-report-testing-service");
const protobufPackage = 'com.step.testapi.proto';
/**
 * Credit Report testing API
 */
class CreditReportTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.CreditReportTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'CreateTestAdminCasCase',
            requestType: credit_report_testing_service_1.CreateTestAdminCaseRequest,
            responseType: credit_report_testing_service_1.CreateTestAdminCaseResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetUserCreditInsight',
            requestType: credit_report_testing_service_1.SetUserCreditInsightRequest,
            responseType: credit_report_testing_service_1.SetUserCreditInsightResponse,
            authenticationOptions: undefined,
        }, {
            name: 'SetDetailedReport',
            requestType: credit_report_testing_service_1.SetDetailedReportRequest,
            responseType: credit_report_testing_service_1.SetDetailedReportResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Create a test credit-report case.
     */
    createTestAdminCasCase(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set credit insight data for a user.
     */
    setUserCreditInsight(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets detailed report for a user.
     */
    setDetailedReport(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CreditReportTestApiServiceClient = CreditReportTestApiServiceClient;
//# sourceMappingURL=credit-report-testapi-service.js.map